import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import styled from 'styled-components';
import Book from './Mobile';
import { colors } from '../../../../constants/colors';

const Root = styled.div`
  margin: 0 -${({ offset }) => offset}px;
  overflow: hidden;
  width: 100vw;
`;

const StickyBook = styled(Book)`
  padding: 10px ${({ padding }) => padding}px;
  background-color: ${colors.white};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  min-height: 40px;
`;

export default class StickyMobile extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    containerPadding: PropTypes.number.isRequired,
    showModal: PropTypes.func.isRequired,
  };

  render = () => {
    const { location, containerPadding, showModal } = this.props;
    return (
      <Root offset={containerPadding}>
        <Sticky top={0} innerZ={1200}>
          <StickyBook padding={containerPadding} location={location} showModal={showModal} />
        </Sticky>
      </Root>
    );
  };
}
